class Task {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
        this.description = json.description;
        this.status = json.status;
    }
}
export default Task;